import React from 'react';
import { DropdownMenuDivider, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { FormattedMessage } from 'react-intl';
import BatchActionLink from '../../../shared/BatchActions/BatchActionLink';
import CancelHoldBatchAction from '../CancelHoldBatchAction';

// TODO: convert this to a proper React component when we update to React 16.
// In React 15 component render methods are not allowed to return arrays, so this has to be a regular function.
export default function renderHoldsBatchActionsOptions({ items, handlePauseHoldsOverlay, handleEditHoldsOverlay, handleResumeHolds, handleOpenBatchCancelOverlay, itemsWithBibs }) {
  const pauseHoldItems = items.filter((item) => item.get('actions').includes('suspend') && !item.get('actions').includes('activate') && !item.get('actions').includes('updateSuspend'));
  const resumeHoldsItems = items.filter((item) => item.get('actions').includes('activate'));

  const itemsWithSuspend = items.filter((item) => item.get('actions').includes('updateSuspend'));
  const metadataIds = itemsWithSuspend.map(item => item.get('metadataId'));
  const selectedBibs = itemsWithBibs.filter((item) => metadataIds.includes(item.getIn(['bib', 'id'])));
  const editHoldsDateItems = selectedBibs.filter(
    bib => (bib.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldStartDate']) === true || bib.getIn(['bib', 'policy', 'materialPolicy', 'supportsSuspendHoldEndDateEdit']) === true));

  const cancelHoldsOption = (
    <CancelHoldBatchAction
      key="batch-cancel-action"
      items={items}
      handleClick={() => handleOpenBatchCancelOverlay()} />
  );

  const editHoldsOption = (
    <DropdownMenuItem key="edit-holds-dropdown-option">
      <BatchActionLink
        disabled={editHoldsDateItems.size === 0}
        handleClick={() => handleEditHoldsOverlay()} >
        <FormattedMessage id="batch_edit_dates_with_count" values={{ count: editHoldsDateItems.size }} />
      </BatchActionLink>
    </DropdownMenuItem>
  );

  const pauseHoldsOption = (
    <DropdownMenuItem key="pause-holds-dropdown-option">
      <BatchActionLink
        disabled={pauseHoldItems.size === 0}
        handleClick={() => handlePauseHoldsOverlay()} >
        <FormattedMessage id="batch_pause_holds_with_count" values={{ count: pauseHoldItems.size }} />
      </BatchActionLink>
    </DropdownMenuItem>
  );

  const resumeHoldsOption = (
    <DropdownMenuItem key="resume-holds-dropdown-option">
      <BatchActionLink
        disabled={resumeHoldsItems.size === 0}
        handleClick={() => handleResumeHolds(resumeHoldsItems)} >
        <FormattedMessage id="batch_resume_holds_with_count" values={{ count: resumeHoldsItems.size }} />
      </BatchActionLink>
    </DropdownMenuItem>
  );

  return [
    cancelHoldsOption,
    resumeHoldsOption,
    pauseHoldsOption,
    editHoldsOption,
    <DropdownMenuDivider key="holds-batch-actions-divider" />
  ];
}



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsBatchActionOptions/HoldsBatchActionOptions.jsx